/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiIdpQueueCleanupExpiredQueuePost$Params {
}

export function apiIdpQueueCleanupExpiredQueuePost(http: HttpClient, rootUrl: string, params?: ApiIdpQueueCleanupExpiredQueuePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiIdpQueueCleanupExpiredQueuePost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiIdpQueueCleanupExpiredQueuePost.PATH = '/api/IdpQueue/cleanup-expired-queue';
